// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { themr } from "react-css-themr";
import { Page, Link, H } from "@lifepay/rc-ui-toolkit";
import { withRouter } from "react-router";
import { Switch, Route, Redirect } from "react-router-dom";

// ABSOLUTE PATH IMPORTS
import Acquiring from "../../Acquiring";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./Acquiring.m.scss";

@withRouter
@themr("front-page", styles)
export default class AcquiringPage extends Component {
  static propTypes = {
    theme: PropTypes.object,
    match: PropTypes.object,
    basePath: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      pageHeader: "Эквайринг",
    };
  }

  setHeader = ({ pageHeader }) => {
    this.setState({ pageHeader });
  };

  render() {
    const { theme, basePath, match } = this.props;
    const { pageHeader } = this.state;
    return match.params.clientId && match.params.clientId[0] === "c" ? (
      <Page
        header={pageHeader}
        showHeader={false}
        breadcrumb={() => (
          <React.Fragment>
            <Link type="alt" to={`/`}>
              {"главная"}
            </Link>
            <div>{"->"}</div>
            <Link type="alt" to={`${basePath}/search`}>
              {"поиск клиента"}
            </Link>
            <div>{"->"}</div>
            <Link type="alt" to={`${basePath}/${match.params.clientId}/menu`}>
              {"выбор действия"}
            </Link>
            <div>{"->"}</div>
            <H t={"h4"}>{pageHeader}</H>
          </React.Fragment>
        )}
      >
        <div className={classnames(theme.wrapper)}>
          <div className={classnames(theme.content)}>
            <Switch>
              <Route
                path={`${match.path}/:subdir`}
                render={() => <Acquiring basePath={`${match.url}`} />}
              />
              <Route
                path="*"
                render={() => <Redirect to={`${match.url}/merchants`} />}
              />
            </Switch>
          </div>
        </div>
      </Page>
    ) : (
      <Redirect to={`${basePath}/search`} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/pages/Acquiring/Acquiring.js